import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import { CFM_UNAVAILABLE_MESSAGE } from '@/utils/cfmLookupErrors'
import { CrmValidateRequest } from '../Types/Requests/CfmRequests'
import { DoctorCrmResponse } from '../Types/Responses/CfmResponses'

export default class CfmService extends Service {
  prefix: string
  constructor() {
    super()
    this.prefix = '/cfm'
  }

  /**
   * Consulta o CRM no CFM (serviço externo, chamado pelo backend). O fallback é
   * a orientação de CFM indisponível: é o que sobra quando o backend responde
   * sem mensagem (400 da chamada SOAP que falhou). 404/400-com-mensagem chegam
   * com o texto do backend; os consumidores classificam o caso com
   * `getCfmLookupFailure` (`@/utils/cfmLookupErrors`).
   */
  async validateCrm(payload: CrmValidateRequest): Promise<DoctorCrmResponse> {
    try {
      const { data } = await request.get<DoctorCrmResponse>(this.getCompletePath(''), payload)
      return data
    } catch (e) {
      throw this.handleError(e, CFM_UNAVAILABLE_MESSAGE)
    }
  }
}
